import * as React from 'react';
import { GptStreamStateProvider } from './gpt-stream-state-context';
import { ChatProvider, createInheritedProvider, EntityGptComponentProvider } from '@shapeable/ui';
import { GptLayout } from '../elements/gpt-layout';
export var defaultGptConfig = {
  activeView: 'question',
  title: 'GPT',
  isShown: false,
  autoPrompts: [],
  usePersonalisation: true
};
export var GptContext = React.createContext(defaultGptConfig);
export var GptContextProvider = createInheritedProvider(GptContext, 'replace');
export var GptProvider = function (_a) {
  var _b = _a.value,
    value = _b === void 0 ? defaultGptConfig : _b,
    children = _a.children;
  var chatConfig = {
    autoPrompts: value.autoPrompts,
    title: value.title
  };
  return React.createElement(ChatProvider, {
    value: chatConfig
  }, React.createElement(EntityGptComponentProvider, {
    value: GptLayout
  }, React.createElement(GptStreamStateProvider, null, React.createElement(GptContextProvider, {
    value: value
  }, children))));
};